<template>
  <div class="content">
    <BlockUI
      v-if="blockScreen"
      :url="blockScreenData.url"
      :message="blockScreenData.msg"
    ></BlockUI>
    <v-card class="pa-3 pb-5">
      <v-flex class="row mx-3 my-2">
        <v-layout align-center>
          <span class="title font-weight-medium">Reembolsos</span>
          <v-spacer></v-spacer>
        </v-layout>
      </v-flex>
      <v-divider class="mx-3"></v-divider>
      <v-flex class="row mx-3 mb-2">
        <v-text-field
          v-model="search"
          append-icon="search"
          label="Procurar"
          single-line
          hide-details
        ></v-text-field>
      </v-flex>
      <v-flex offset-lg10>
        <download-excel
          class="ml-auto mr-0"
          :data="data"
          :fields="json_fields"
          name="veiculos.xls"
        >
          <v-btn small class="mr-4">
            <span class="pr-1">Exportar</span>
            <v-icon small class="black--text">insert_drive_file</v-icon>
          </v-btn>
        </download-excel>
      </v-flex>
      <v-data-table
        no-data-text="Nenhum reembolso reportado"
        footer-props.items-per-page-text="Linhas por página"
        :headers="headers"
        :items="data"
        :search="search"
        class="table-custom-vue elevation-1 mt-2"
        :rows-per-page-items="[
          10,
          25,
          { text: '$vuetify.dataIterator.rowsPerPageAll', value: -1 },
        ]"
      >
        <template v-slot:item="{ item }">
          <tr>
            <td>{{ item.vehicle_request.user.name }}</td>
            <td class>{{ item.vehicle_request.id }}</td>
            <td class>{{ item.reason }}</td>
            <td class>{{ item.receive_value | formatPrice }}</td>
            <td class>
              <a
                :href="`https://pickndrive.s3-sa-east-1.amazonaws.com/${item.url_nfs}`"
                target="_blank"
                >Visualizar</a
              >
            </td>
            <td class>{{ item.create_date | formatDate }}</td>
            <td class>{{ item.status | status }}</td>
            <td class>
              <ActionButton
                message="Visualizar Reserva"
                icon="pageview"
                @onclick="viewReservation(item.vehicle_request.id)"
              />
              <ActionButton
                message="Executar Reembolso"
                icon="check"
                color="success"
                @onclick="reimburse(item)"
              />
            </td>
          </tr>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
import RefoundController from '../../controllers/RefoundController.js';
import NumberHelper from './../../helpers/NumberHelper';
import { blockScreenUi } from '../../helpers/BlockScreenUi';
import moment from 'moment';
import ActionButton from '../shared/ActionButtonsTemplate';

export default {
  components: {
    ActionButton,
  },
  created() {
    this.getRefounds();
  },
  data() {
    return {
      refoundController: new RefoundController(this.$resource),
      blockScreenData: blockScreenUi.blockScreenData,
      blockScreen: false,
      search: '',
      data: [],
      showModal: false,
      refound: {},
      json_fields: {
        Reserva: 'vehicle_request.id',
        Motivo: 'reason',
        User: 'vehicle_request.user.name',
        ValorSolicitado: 'receive_value',
      },
      headers: [
        { text: 'User', value: 'vehicle_request.user.name' },
        { text: 'Reserva', value: 'vehicle_request.id' },
        { text: 'Motivo', value: 'reason' },
        { text: 'Valor solicitado', value: 'receive_value' },
        { text: 'Comprovante de gasto', value: 'url_nfs' },
        { text: 'Data de solicitação', valure: 'create_date' },
        { text: 'Status', value: 'status' },
        { text: 'Ações', value: 'action', sortable: false },
      ],
    };
  },
  filters: {
    formatPrice(price) {
      return `R$ ${NumberHelper.formatPrice(price)} `;
    },
    status(sts) {
      if (sts == 'pending') return 'Pendente';
      else return 'Realizado';
    },
    formatDate(dateString) {
      if (dateString) {
        return moment(dateString).format('DD[/]MM[/]YYYY HH:mm');
      }
    },
  },
  methods: {
    async getRefounds() {
      this.blockScreen = true;
      await this.refoundController
        .getAll()
        .then((response) => {
          this.data = response;
        })
        .catch((error) => {
          this.$awn.alert('Falha ao obter reembolsos');
        });
      this.blockScreen = false;
    },

    async createRefoundReceipt(data) {
      this.refoundController.createRefoundReceipt(data);
    },

    viewReservation(id) {
      this.$router.push('/tcs/reserva/' + id);
    },
    reimburse(data) {
      swal({
        title: 'Deseja realiza o reembolso?',
        icon: 'success',
        buttons: true,
        dangerMode: true,
      }).then((willApprovall) => {
        if (willApprovall) {
          data.status = 'done';
          this.blockScreen = true;
          this.refoundController
            .update(data)
            .then((response) => {
              this.$awn.success('Reembolso realizado!');
              this.createRefoundReceipt(data);
            })
            .catch((error) => {
              this.$awn.alert('Falha ao realizar reembolso');
            })
            .finally(() => {
              this.blockScreen = false;
            });
        }
      });
    },
  },
};
</script>
<style lang="scss">
.table-custom-vue {
  margin: 20px;
}
.table-custom-vue td:last-child {
  display: flex;
  justify-content: center;
}
.new-car-button {
  border: none;
  &:hover {
    color: white;
    background: var(--primary-color-hover);
  }
}

td.layout {
  display: flex;
  justify-content: space-between !important;
  align-items: center;
}

.open-button {
  color: var(--primary-color);
  &:hover {
    color: var(--primary-color-hover);
  }
}

.close-button {
  color: var(--red-color);
  &:hover {
    color: var(--red-color-hover);
  }
}

.car-open-buttons:hover {
  cursor: pointer;
}
</style>
